module.exports = __webpack_public_path__ + "static/11-49fb1fe97fb70eb96d9cd338984d3f1a.jpg";